import { AxiosResponse } from "axios";
import dayjs from "dayjs";
import FileSaver from "file-saver";

export function calculateResidualDays(complaintDate : Date){
    const date1 = dayjs(complaintDate).add(30, 'day');
    const diff = date1.diff(dayjs(),'day',true);
    return Math.floor(diff) >= 0 ?  Math.floor(diff) : "";
}

export function calculateDateDifference(date : Date){
    const diff = dayjs().diff(dayjs(date),'day',true);
    return Math.floor(diff) >= 0 ?  Math.floor(diff) : "";
}

export const saveFileFromResponse = (response: AxiosResponse, fileName?: string) => {
    const filename = fileName || response?.headers?.["content-disposition"]?.split("filename=")[1] || "Download";
    const blob = new Blob([response.data], {type: response.headers["content-type"]});
    FileSaver.saveAs(blob, filename);
}